import ServiceDetailComponent from "@/components/Services/ServiceDetailComponent";

const ServiceDetail = () => {
  return <ServiceDetailComponent />;
};

export default ServiceDetail;
